import { render, staticRenderFns } from "./UnderwritingQualifications.vue?vue&type=template&id=34ee48a8"
import script from "./UnderwritingQualifications.vue?vue&type=script&lang=ts"
export * from "./UnderwritingQualifications.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports